import { mergeAttributes } from '@tiptap/core';
import TaskItem from '@tiptap/extension-task-item';
import TaskList from '@tiptap/extension-task-list';

const HTML_ATTRIBUTE_DIR_AUTO = { dir: 'auto' };

export const ChecklistList = TaskList.configure({
  HTMLAttributes: HTML_ATTRIBUTE_DIR_AUTO,
});

export const ChecklistItem = TaskItem
  .extend({
    /**
     * Adds `disabled` to checkboxes in generated HTML. This ensures checkboxes
     * in read-only reports (rendered via v-html) remain non-interactive.
     */
    renderHTML({ node, HTMLAttributes }) {
      return [
        'li',
        mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
          'data-type': this.name,
        }),
        [
          'label',
          [
            'input',
            {
              type: 'checkbox',
              checked: node.attrs.checked ? 'checked' : null,
              disabled: 'disabled',
            },
          ],
          ['span'],
        ],
        ['div', 0],
      ];
    },

    /**
     * The live checkbox ignores renderHTML, so a read-only editor would otherwise show an enabled,
     * focusable input. TextEditor recreates the editor when `disabled` changes, so reading
     * isEditable once at creation is enough.
     */
    addNodeView() {
      const createNodeView = this.parent?.();

      return (props) => {
        const nodeView = createNodeView(props);
        const checkbox = nodeView.dom.querySelector('input[type="checkbox"]');

        if (checkbox) {
          checkbox.disabled = !props.editor.isEditable;
        }

        return nodeView;
      };
    },
  })
  .configure({
    nested: true,
  });
